import { CHART_EDIT_TAGS_TABLE_STRINGS } from "constants/constantStrings";

import ChartTagCheckboxRenderer from "./ChartTagCheckboxRenderer.jsx";
import ChartTagColorRenderer from "./ChartTagColorRenderer.jsx";
import ChartTagDeleteRenderer from "./ChartTagDeleteRenderer.jsx";
import ChartTagHeaderCheckboxRenderer from "./ChartTagHeaderCheckboxRenderer.jsx";
import ChartTagLowerLimitRenderer from "./ChartTagLowerLimitRenderer.jsx";
import ChartTagTypeRenderer from "./ChartTagTypeRenderer";
import ChartTagUpperLimitRenderer from "./ChartTagUpperLimitRenderer.jsx";
import ChartTrendCheckboxRenderer from "./ChartTrendCheckboxRenderer.jsx";
import ChartTrendHeaderRenderer from "./ChartTrendHeaderRenderer.jsx";

const CHART_TAG_TABEL_COL_DEF = [
  {
    field: "",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerDisplay,
    flex: 1.1,
    editable: false,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    headerComponentParams: { field: "" },
    headerComponentFramework: ChartTagHeaderCheckboxRenderer,
    cellRendererFramework: ChartTagCheckboxRenderer
  },
  {
    field: "Trendline",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerTrendline,
    flex: 1,
    minWidth: 120,
    editable: false,
    sortable: false,
    headerComponentFramework: ChartTrendHeaderRenderer,
    cellRendererFramework: ChartTrendCheckboxRenderer
  },
  {
    field: "TagId",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerTagID,
    flex: 1.5,
    editable: false,
    sortable: true
  },
  {
    field: "TagName",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerTagName,
    flex: 2,
    editable: false,
    sortable: true
  },
  {
    field: "Units",
    flex: 1,
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerUnit,
    editable: false,
    sortable: true
  },
  {
    field: "Ylower",
    flex: 1.5,
    headerName: "Lower Limit",
    editable: false,
    sortable: false,
    cellRendererFramework: ChartTagLowerLimitRenderer
  },
  {
    field: "Yupper",
    flex: 1.5,
    headerName: "Upper Limit",
    editable: false,
    sortable: false,
    cellRendererFramework: ChartTagUpperLimitRenderer
  },
  {
    field: "Color",
    flex: 1.5,
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerColor,
    editable: false,
    sortable: false,
    cellRendererFramework: ChartTagColorRenderer
  },
  {
    field: "Type",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerType,
    flex: 1.5,
    editable: false,
    minWidth: 130,
    sortable: false,
    cellRendererFramework: ChartTagTypeRenderer
  },

  // ToDo: Keeping this commented code as it might require in future
  // {
  //   field: 'Position',
  //   flex: 1,
  //   headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerPosition,
  //   editable: false,
  //   sortable: false,
  //   cellRendererFramework: ChartTagPositionRenderer
  // },
  {
    field: "",
    headerName: CHART_EDIT_TAGS_TABLE_STRINGS.headerDelete,
    editable: false,
    sortable: false,
    cellRendererFramework: ChartTagDeleteRenderer,
    flex: 0.75
  }
];

export const getAlarmsTableColDef = getAvailableColors =>
  CHART_TAG_TABEL_COL_DEF.map((colDef, idx) => {
    if (colDef.field === "Color") {
      colDef = { ...colDef, cellRendererParams: { getAvailableColors } };
    }
    return colDef;
  });
